import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Form } from 'antd';
import Drawer from 'components/AntEnhancement/Drawer';
import { Check, X } from 'lucide-react';
import TransactionForm from 'components/forms/accounting/transactions/TransactionForm';
import localeTranslator from 'library/Hocs/LocalTranslator';
import { Transaction } from 'models';
import services from 'services';
import './ExpenseDrawer.css';
var ExpenseDrawer = function (props) {
    var visiable = props.visiable, onCloseDrawer = props.onCloseDrawer, t = props.translate;
    var _a = useState(function () { return new Transaction(); }), transaction = _a[0], setTransaction = _a[1];
    var _b = useState(false), saving = _b[0], setSaving = _b[1];
    var form = Form.useForm()[0];
    var transactionService = services.transactionService, documentLineGroupService = services.documentLineGroupService;
    var createTransaction = transactionService.useCreateTransaction().mutate;
    var expenseGroups = documentLineGroupService.useExpenseGroups().data;
    var ready = Boolean(expenseGroups);
    var close = function () {
        form.resetFields();
        setTransaction(new Transaction());
        setSaving(false);
        onCloseDrawer();
    };
    var submit = function () {
        if (saving)
            return;
        setSaving(true);
        createTransaction({ transaction: transaction, successMessage: t('transactionCreated') }, {
            onSuccess: function () {
                close();
            },
            onError: function () { return setSaving(false); }
        });
    };
    return (_jsx(Drawer, { title: null, placement: "right", open: visiable, onClose: close, closable: false, destroyOnClose: true, width: 520, rootClassName: "exp-drawer", className: "exp-drawer", children: _jsxs(Form, { layout: "vertical", className: "exp-drawer__shell", form: form, requiredMark: false, onFinish: submit, onFinishFailed: function () { return form.scrollToField('documentLineGroup', { behavior: 'smooth' }); }, children: [_jsxs("header", { className: "exp-drawer__header", children: [_jsxs("div", { children: [_jsx("h2", { className: "exp-drawer__title", children: t('title') }), _jsx("p", { className: "exp-drawer__subtitle", children: t('subtitle') })] }), _jsx("button", { type: "button", className: "exp-drawer__close", onClick: close, "aria-label": t('common:buttons.close'), children: _jsx(X, { size: 18, strokeWidth: 2 }) })] }), _jsx("div", { className: "exp-drawer__body", children: ready && expenseGroups ? (_jsx(TransactionForm, { documentLineGroups: expenseGroups, transaction: transaction })) : (_jsx("div", { className: "exp-drawer__placeholder" })) }), _jsxs("footer", { className: "exp-drawer__footer", children: [_jsx("button", { type: "button", className: "exp-drawer__btn exp-drawer__btn--ghost", onClick: close, children: t('common:buttons.cancel') }), _jsxs("button", { type: "submit", className: "exp-drawer__btn exp-drawer__btn--primary", disabled: saving || !ready, children: [_jsx(Check, { size: 16, strokeWidth: 2 }), _jsx("span", { children: t('common:buttons.submit') })] })] })] }) }));
};
export default localeTranslator(ExpenseDrawer, 'transactionForm');
